// Import directly from users module to avoid circular dependency with @sol/sdk barrel export
import { IUserResource } from "../users";

export const getUserDisplayName = (user: Pick<IUserResource, "name" | "surname" | "email">) => {
    if (!user.name || !user.surname) {
        return user.email;
    }

    return `${user.name} ${user.surname}`;
};
